import { useState, useEffect } from "react";
import { useAuth0 } from "react-auth0-spa";
import { Container, Link, Typography } from "@mui/material";
import Axios from "axios";
import { useCookies } from "react-cookie";
import Title from "./Components/Title";
import { CHECKOUT_ENDPOINT } from "Utils/Constants";

const ThankYouFreeTrial = (props: any) => {
  const { isAuthenticated, refreshUserSilently, user } = useAuth0();
  const [isFreeTrialApplied, setIsFreeTrialApplied] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const [cookies] = useCookies(["freeTrialCoupon", "freeTrialVersion"]);

  const freeTrialCouponCookie = cookies.freeTrialCoupon;
  const freeTrialVersionCookie = cookies.freeTrialVersion;

  const getCustomer = (userInfo, freeTrialVersion) => {
    return {
      first_name: userInfo?.given_name,
      last_name: userInfo?.family_name,
      email: userInfo?.email,
      auth0_id: userInfo?.sub,
      meta_data: { freeTrialVersion },
    };
  };

  useEffect(() => {
    refreshUserSilently();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // console.log("🚀 ~ ThankYouFreeTrial ~ isAuthenticated:", isAuthenticated);
    // console.log("🚀 ~ ThankYouFreeTrial ~ user:", user);

    if (
      !isAuthenticated ||
      !user ||
      !freeTrialCouponCookie ||
      !freeTrialVersionCookie ||
      isFreeTrialApplied ||
      isError ||
      user?.plan
    ) {
      return;
    }

    // console.log(
    //   "🚀 ~ useEffect ~ freeTrialVersionCookie:",
    //   freeTrialVersionCookie
    // );
    // console.log(
    //   "🚀 ~ useEffect ~ freeTrialCouponCookie:",
    //   freeTrialCouponCookie
    // );

    // console.log("🚀 ~ useEffect ~ isFreeTrialApplied:", isFreeTrialApplied);

    createFreeTrialPlan();

    // @todo call API to add Free Trial to member
    async function createFreeTrialPlan() {
      try {
        setIsFreeTrialApplied(true);
        await Axios.post(
          process.env.REACT_APP_API_ENDPOINT + "/checkout/coupon",
          {
            coupon: freeTrialCouponCookie,
            plan: "",
            freeTrial: true,
          }
        );

        await Axios.post(
          process.env.REACT_APP_API_ENDPOINT + CHECKOUT_ENDPOINT + "/v2",
          {
            captcha: "abc123",
            customer: getCustomer(user, freeTrialVersionCookie),
            shippingAddress: {},
            amount: 1000,
            paymentMethod: {
              type: "freeTrial",
            },
            autoRenew: false,
            monthly: true,
            plan: null,
            coupon: freeTrialCouponCookie,
            shipping: "",
            gift: "",
            isGift: false,
            giftRecipient: {},
            dev: process.env.REACT_APP_NODE_ENV === "dev",
            password: undefined,
          }
        );

        refreshUserSilently();
      } catch (e: any) {
        // console.log("error occured: ", e);
        setIsError(true);
      }
    }
  }, [
    freeTrialCouponCookie,
    freeTrialVersionCookie,
    isAuthenticated,
    isError,
    isFreeTrialApplied,
    user,
    refreshUserSilently,
  ]);

  if (isError)
    return (
      <Container
        maxWidth="sm"
        sx={(theme) => ({ textAlign: "center", ...theme.mixins.pageContent })}
      >
        An error has occured, please{" "}
        <Link
          href="mailto: support@jazzgroove.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact Us
        </Link>{" "}
        for support.
      </Container>
    );

  return (
    <Container
      maxWidth="sm"
      sx={(theme) => ({ textAlign: "center", ...theme.mixins.pageContent })}
    >
      <Title value="Thank You" />
      <Typography variant="h1" sx={{ mb: 3 }}>
        Thank you
        {user?.given_name && `, ${user.given_name} ${user?.family_name}`}!
      </Typography>
    </Container>
  );
};

export default ThankYouFreeTrial;
